import { filter, mapTo, take } from "rxjs/operators";
import { TypeActionTutorial } from "../../../tutorial/actionTutorial";
import { IdTutorialStep } from "../../../tutorial/IdTutorialStep";
import { actionGameTrackingUpdateClientFunnel } from "../../actionGameTracking";
import { IdGameTrackingClientFunnelState } from "../IdGameTrackingClientFunnelState";
export var epicGameTrackingClientFunnelTutorialStart = function (action$, state$, deps) {
    return action$.pipe(filter(function (action) {
        return action.type === TypeActionTutorial.Select &&
            action.tutorialStep === IdTutorialStep.welcome_clickConfirmButton;
    }), take(1), mapTo(actionGameTrackingUpdateClientFunnel(IdGameTrackingClientFunnelState.TUTORIAL_START)));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/game-tracking/game-funnel/epics/epicGameTrackingClientFunnelTutorialStart.ts
// module id = 1874
// module chunks = 3